import React from "react";
import Translate from "../../helpers/translate"; // Styles

import "./404.styles.scss";

function NotFound({
  error
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "react__pdf--404"
  }, /*#__PURE__*/React.createElement("h3", null, Translate({
    id: "the_pdf_file_cannot_be_loaded_please_make_sure_the_url_exists_and_your_internet_is_up_and_running"
  })), error && /*#__PURE__*/React.createElement("code", {
    className: "mt-20"
  }, error));
}

export default NotFound;